import axios from 'axios'
import store from '../store/store'
// import { Message } from 'element-ui'
const baseURL = store.state.baseUrl
const api = axios.create({
  baseURL: baseURL,
  timeout: 30000
}) // 添加请求拦截器

api.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  config.data = { ...config.data }// token: store.state.token
  config.headers['App-Type'] = 1
  config.headers.schoolid = 327
  config.headers.Version = 'v1'
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
}) // 添加响应拦截器

api.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  if (response.data.errcode === 0) {
    return response
  } else {
    // Message({
    // message: response.data.msg,
    // type: "error"
    // })
    return Promise.reject(response.data.errmsg)
  }
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error)
})
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get (url, params = {}) {
  return new Promise((resolve, reject) => {
    api.get(url, {
      params: params
    }).then(response => {
      resolve(response.data)
    }).catch(err => {
      reject(err)
    })
  })
}
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post (url, data = {}) {
  return new Promise((resolve, reject) => {
    api.post(url, data).then(response => {
      resolve(response.data)
    }, err => {
      reject(err)
    })
  })
}
/**
* 封装patch请求
* @param url
* @param data
* @returns {Promise}
*/

export function patch (url, data = {}) {
  return new Promise((resolve, reject) => {
    api.patch(url, data).then(response => {
      resolve(response.data)
    }, err => {
      reject(err)
    })
  })
}
/**
* 封装put请求
* @param url
* @param data
* @returns {Promise}
*/

export function put (url, data = {}) {
  return new Promise((resolve, reject) => {
    api.put(url, data).then(response => {
      resolve(response.data)
    }, err => {
      reject(err)
    })
  })
}
